import React from "react";
import Loader from "react-loader-spinner";

const LoaderHOC = WrappedComponent => {
  return function LoaderHOC({ loading, ...props }) {
    return loading ? (
      <div className="w3-container w3-center">
        <Loader type="TailSpin" color="#1797be" height={100} width={100} />
      </div>
    ) : (
      <WrappedComponent loading={loading} {...props} />
    );
  };
};

export default LoaderHOC;
